import { render, staticRenderFns } from "./brigad_ajiliin_bairnii_zar_details.vue?vue&type=template&id=e1d6de04&scoped=true&"
import script from "./brigad_ajiliin_bairnii_zar_details.vue?vue&type=script&lang=js&"
export * from "./brigad_ajiliin_bairnii_zar_details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1d6de04",
  null
  
)

export default component.exports